import { useListView } from '../../core/ListViewProvider'
import { SignAsoListGrouping } from './SignAsoListGrouping'
import { SignAsoListSearchComponent } from './SignAsoListSearchComponent'

export const SignAsoListHeader = () => {
  const { selected } = useListView()

  return (
    <div className='card-header border-0 pt-6'>
      <SignAsoListSearchComponent
        actions={selected.length > 0 ? <SignAsoListGrouping /> : undefined}
      />
    </div>
  )
}
